import React from "react";
import { View, StyleSheet } from "react-native";
import { brand } from "@/constants";
import Text from "./base/Text";

/**
 * Props for the AppTitle component
 */
interface AppTitleProps {
  /** Additional styles to apply to the container */
  style?: any;
}

/**
 * AppTitle component that displays the brand name with "PREVIEW" badge
 */
export default function AppTitle({ style }: AppTitleProps) {
  return (
    <View style={[styles.container, style]}>
      <Text variant="bold" size="xlarge" color="primary">
        {brand.name}
      </Text>
      <Text variant="regular" size="small" color="secondary">
        {" "}
        PREVIEW
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "baseline"
  }
});
